module.exports = __webpack_public_path__ + "img/TUR-i-2-II.cb1eba3e.png";